import React, { createContext, useContext } from "react";

export const GlobalConfigContext = createContext(null);

export function GlobalConfigProvider({ config, children }) {
  return (
    <GlobalConfigContext.Provider value={config}>
      {children}
    </GlobalConfigContext.Provider>
  );
}

export function useGlobalConfig() {
  return useContext(GlobalConfigContext);
}
